import { IAssetPerformanceCollection } from 'src/app/models/holdings';
import { ClientEntity } from 'src/app/models/clients';
import { AssetRevenueState } from "src/app/models/holdings";
import {IPortfolio} from "../../models/portfolios";

export interface IHoldingsState {
    holdingsValuationData: any[];
    holdingsExposuresData: [];
    selectedDate?: Date;
    selectedEntities?: ClientEntity[];
    selectedPortfolios?: IPortfolio[];
    loading: boolean;
    error: boolean;
    errorMessage: string;
    selectedAssetPerformanceCollection: IAssetPerformanceCollection;
    selectedAssetRevenue: AssetRevenueState;
    selectedAssetId: number;
    portfolioValue: number;
    entities: {}[];
    availableBalance: number;
    isValuationsDataLoaded: boolean;
}

export const initialHoldingsState: IHoldingsState = {
    holdingsValuationData: [],
    holdingsExposuresData: [],
    loading: false,
    error: false,
    errorMessage: '',
    selectedAssetPerformanceCollection: {},
    selectedAssetRevenue: {},
    selectedAssetId: null,
    portfolioValue: 0,
    entities: [],
    availableBalance: 0,
    isValuationsDataLoaded: false,
    selectedEntities: [],
    selectedPortfolios: [],
};
